const API_ENDPOINT = "https://127.0.0.1:8000/analyze-task" // Replace with your actual API endpoint

export const analyzeTask = async (task) => {
  try {
    const response = await fetch(API_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ task }),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    console.error("API request failed:", error)
    throw error // Re-throw the error for the component to handle
  }
}

export const getMockAnalysis = (task) => {
  // Simple mock data based on the task
  const taskLower = task.toLowerCase()

  if (taskLower.includes("speaking")) {
    return {
      brain_regions: ["Frontal Lobe", "Temporal Lobe", "Broca's Area"],
      cognitive_effects: ["Language processing", "Speech production"],
      damage_risks: ["Aphasia", "Speech impairment"],
      stress_level: "moderate",
    }
  } else if (taskLower.includes("reading")) {
    return {
      brain_regions: ["Occipital Lobe", "Temporal Lobe", "Parietal Lobe"],
      cognitive_effects: ["Visual processing", "Language comprehension"],
      damage_risks: ["Alexia", "Reading difficulties"],
      stress_level: "low",
    }
  } else if (taskLower.includes("listening")) {
    return {
      brain_regions: ["Temporal Lobe", "Auditory Cortex"],
      cognitive_effects: ["Auditory processing", "Information retrieval"],
      damage_risks: ["Hearing impairment", "Auditory agnosia"],
      stress_level: "low",
    }
  } else if (taskLower.includes("learning")) {
    return {
      brain_regions: ["Hippocampus", "Prefrontal Cortex"],
      cognitive_effects: ["Memory formation", "Cognitive flexibility"],
      damage_risks: ["Memory loss", "Learning disabilities"],
      stress_level: "moderate",
    }
  } else if (taskLower.includes("happy to sad")) {
    return {
      brain_regions: ["Amygdala", "Prefrontal Cortex", "Limbic System", "Hypothalamus"],
      cognitive_effects: [
        "Emotional Regulation Shift",
        "Decreased Dopamine Activity",
        "Increased Cortisol Release",
        "Altered Serotonin Signaling",
      ],
      damage_risks: ["Prolonged Negative Mood", "Stress Response Activation", "Cognitive Distortion"],
      stress_level: "elevated",
      mood_transition: {
        from: "happy",
        to: "sad",
        regions_activation: [
          { region: "Amygdala", change: "increasing" },
          { region: "Prefrontal Cortex", change: "decreasing" },
        ],
        neurotransmitters: [
          { name: "Dopamine", change: "decreasing" },
          { name: "Serotonin", change: "decreasing" },
        ],
      },
    }
  } else if (taskLower.includes("grief to deep thoughts")) {
    return {
      brain_regions: ["Amygdala", "Prefrontal Cortex", "Anterior Cingulate Cortex", "Hippocampus"],
      cognitive_effects: ["Emotional Processing", "Memory Consolidation", "Abstract Reasoning", "Self-Reflection"],
      damage_risks: ["Rumination", "Emotional Exhaustion", "Memory Distortion"],
      stress_level: "fluctuating",
      mood_transition: {
        from: "grief",
        to: "deep thoughts",
        regions_activation: [
          { region: "Amygdala", change: "decreasing" },
          { region: "Prefrontal Cortex", change: "increasing" },
          { region: "Hippocampus", change: "increasing" },
        ],
        neurotransmitters: [
          { name: "Norepinephrine", change: "decreasing" },
          { name: "Glutamate", change: "increasing" },
        ],
      },
    }
  } else {
    return {
      brain_regions: ["Prefrontal Cortex"],
      cognitive_effects: ["General processing"],
      damage_risks: ["Cognitive decline"],
      stress_level: "normal",
    }
  }
}
